// @flow
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { AXIOS_ERROR_MESSAGE } from "../../../../locales/components/namespaces";

type Props = {
	errorMessage: String,
	errorCode: Number
};

const ErrorMessage = ({ errorMessage, errorCode, responseMessage }: Props) => {
	const { t } = useTranslation(AXIOS_ERROR_MESSAGE)
	return (
		<Box>
			<span>{`${t('Code')}: ${errorCode}`}</span><br/>
			<span>{`${t('Message')}: ${errorMessage}`}</span><br/>
			{responseMessage && (<span>{`${t('Message')}: ${responseMessage}`}</span>)}
		</Box>
	);
};

export default ErrorMessage